const ADD_APP = async ({ commit }, app) => {
  commit('ADD_APP', app);
};

const DELETE_APP = async ({ commit }, app) => {
  commit('DELETE_APP', app);
};

const SET_APPS = async ({ commit }, apps) => {
  commit('SET_APPS', apps);
};

export default {
  ADD_APP,
  DELETE_APP,
  SET_APPS,
};
